import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Trash2 = (props) => (
  <Icon viewBox="0 0 13 15" {...props}>
    <g>
      <title>remove</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M1 3l1-1v10.997A.995.995 0 0 0 2.992 14h7.016c.542 0 .992-.451.992-1.003V2l1 1H1zm0-1h11v10.997C12 14.103 11.1 15 10.008 15H2.992C1.892 15 1 14.106 1 12.997V2z"
        />
        <path d="M9 2L8 3V1.5c0-.28-.221-.5-.5-.5h-2c-.275 0-.5.225-.5.5V3L4 2h5zm0 1H4V1.5C4 .672 4.674 0 5.5 0h2C8.328 0 9 .666 9 1.5V3zM4 6.5V11h1V6H4zM6 6.5V11h1V6H6zM8 6.5V11h1V6H8z"
        />
        <path d="M.5 3H13V2H0v1z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Trash2;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Trash2.js